// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b4dea6cf","732":"6615625b","977":"de1a80ea"}[chunkId] + ".chunk.js";
};